import { lazy } from 'react';

// Components
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "outOfStockModal" */ './OutOfStockModal')),
);

const LazyComponentWithSuspense = withSuspense<{}>(LazyComponent, 'OutOfStockModal');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as OutOfStockModal };
